import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ProductBrowser from 'components/admin/Products/Segments/ProductBrowser'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { formValues } from 'redux-form'
import { Grid, Segment, Table } from 'semantic-ui-react'
import CategoryProductRow from './CategoryProductRow'
import CategoryProperties from './CategoryProperties'

const i18nkey = 'admin.product.categories.ProductFamilyMembers.'

const mapStateToProps = (state, ownProps) => {
  const { properties } = state.properties
  const { category } = state.categories
  const { products } = state.product
  //  const categoryProperties = properties && ownProps.formValues ? ownProps.formValues.properties.map(categoryProperty => properties.find(property => property.id === categoryProperty.property_id) || {}) : new Array(5).fill({});

  return { properties, category, products }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class CategoryProducts extends React.Component {
  state = {
    dragMarker: {},
  }

  addProduct(article_number) {
    const { products, array } = this.props
    const product = products.find(
      (product) => product.article_number === article_number
    )
    if (product) array.push('productIds', product.id)
  }

  moveProduct(oldIndex, newIndex) {
    const { array } = this.props
    array.move('productIds', oldIndex, newIndex)
  }

  unlinkProduct(index) {
    const { array } = this.props
    array.remove('productIds', index)
  }

  findProduct(dragId) {
    const { productIds = [] } = this.props
    const item = productIds.find((productId) => productId === dragId)
    return {
      item,
      index: productIds.indexOf(item),
    }
  }

  productRows() {
    const { dragMarker = {} } = this.state
    const { products = [], properties = [] } = this.props //redux
    const { formProperties = [], productIds = [] } = this.props //formValues
    const categoryProperties = formProperties.map(
      (categoryProperty) =>
        properties.find(
          (property) => property.id === categoryProperty.property_id
        ) || {}
    )
    return productIds.map((productId, index) => {
      const product =
        (products && products.find((product) => product.id === productId)) || {}
      return (
        <CategoryProductRow
          {...{
            key: index,
            product: product,
            index: index,
            dragId: product.id,
            categoryProperties: categoryProperties,
            unlinkProduct: (index) => this.unlinkProduct(index),
            findItem: (dragId) => this.findProduct(dragId),
            moveItem: (oldIndex, newIndex) =>
              this.moveProduct(oldIndex, newIndex),
            setDragMarker: (dragMarker) => this.setState({ dragMarker }),
            dragMarker: dragMarker,
          }}
        />
      )
    })
  }

  /*
    getTableHeader() {
      const { properties = [] } = this.props; //redux
      const { formProperties = [] } = this.props; //formValues
      const categoryProperties = formProperties.map(categoryProperty => properties.find(property => property.id === categoryProperty.property_id) || {});
      return [
        <Table.HeaderCell key={-2} collapsing/>,
        <Table.HeaderCell key={-1}>ArtNr / Bezeichnung</Table.HeaderCell>
      ].concat(
        categoryProperties.map((property, index) => (
          <Table.HeaderCell key={index}>
            {property.name_de}
          </Table.HeaderCell>
        ))
      ).concat(<Table.HeaderCell collapsing/>);
    }
  */

  render() {
    const dark = config.theme.dark
    const { array } = this.props //ownProps
    const { productIds = [] } = this.props //formValues
    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={7}>
            <CategoryProperties {...{ array }} />

            <ComponentHeader
              inline
              icon={config.icons.attach}
              title={I18n.t(i18nkey + 'products')}
            />
            <Segment
              attached
              className={classNames(['payload', dark && 'inverted'])}>
              <Table
                compact
                size="small"
                selectable
                basic="very"
                className="spaced like-sortable">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell collapsing />
                    <Table.HeaderCell>ArtNr / Bezeichnung</Table.HeaderCell>
                    <Table.HeaderCell collapsing />
                  </Table.Row>
                </Table.Header>
                <Table.Body children={this.productRows()} />
              </Table>
            </Segment>
          </Grid.Column>

          <Grid.Column width={5}>
            <ProductBrowser
              inline
              selectable="left"
              inverted={false}
              download={false}
              onSelect={(articleNumber) => this.addProduct(articleNumber)}
              exclude={productIds}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

CategoryProducts = connect(mapStateToProps, mapDispatchToProps)(
  CategoryProducts
)
CategoryProducts = formValues({
  formProperties: 'properties',
  productIds: 'productIds',
})(CategoryProducts)
export default CategoryProducts



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryProducts.jsx